/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Ats_Score_CtaInputs */

const en_onboarding_ats_score_cta = /** @type {(inputs: Onboarding_Ats_Score_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tailor Now`)
};

const de_onboarding_ats_score_cta = /** @type {(inputs: Onboarding_Ats_Score_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt anpassen`)
};

const fr_onboarding_ats_score_cta = /** @type {(inputs: Onboarding_Ats_Score_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adapter maintenant`)
};

const es_onboarding_ats_score_cta = /** @type {(inputs: Onboarding_Ats_Score_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adaptar ahora`)
};

const it_onboarding_ats_score_cta = /** @type {(inputs: Onboarding_Ats_Score_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adatta ora`)
};

const nl_onboarding_ats_score_cta = /** @type {(inputs: Onboarding_Ats_Score_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu aanpassen`)
};

const pl_onboarding_ats_score_cta = /** @type {(inputs: Onboarding_Ats_Score_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostosuj teraz`)
};

const fi_onboarding_ats_score_cta = /** @type {(inputs: Onboarding_Ats_Score_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Räätälöi nyt`)
};

const da_onboarding_ats_score_cta = /** @type {(inputs: Onboarding_Ats_Score_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilpas nu`)
};

const sv_onboarding_ats_score_cta = /** @type {(inputs: Onboarding_Ats_Score_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anpassa nu`)
};

/**
* | output |
* | --- |
* | "Tailor Now" |
*
* @param {Onboarding_Ats_Score_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_ats_score_cta = /** @type {((inputs?: Onboarding_Ats_Score_CtaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Ats_Score_CtaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_ats_score_cta(inputs)
	if (locale === "fr") return fr_onboarding_ats_score_cta(inputs)
	if (locale === "es") return es_onboarding_ats_score_cta(inputs)
	if (locale === "it") return it_onboarding_ats_score_cta(inputs)
	if (locale === "nl") return nl_onboarding_ats_score_cta(inputs)
	if (locale === "pl") return pl_onboarding_ats_score_cta(inputs)
	if (locale === "fi") return fi_onboarding_ats_score_cta(inputs)
	if (locale === "da") return da_onboarding_ats_score_cta(inputs)
	if (locale === "sv") return sv_onboarding_ats_score_cta(inputs)
	return en_onboarding_ats_score_cta(inputs)
});